import { useContext } from "react";
import { UUID } from "crypto";
import { NawyPassportContext } from "@/modules/common/context/nawy-passport.provider";
import { userHasPermission } from "@/modules/common/utils";
import { PermissionLevel, PermissionsEnum } from "@/modules/common/types";
import PermissionGuard from "@/modules/common/components/wrappers/permission-guard";
import ResponsiveModal from "@/modules/common/components/ui-kit/modals/responsive-modal";
import EditMethodOfContact from "@/modules/lead-page/components/lead-info/edit-fields/method-of-contact";
import LeadInfoField from "@/modules/lead-page/new/components/lead-info-field";
import useLeadInfo from "@/modules/lead-page/hooks/lead-info/lead-info.hook";
import usePartnersWithMethodOfContact from "@/modules/common/hooks/partners-with-method-of-contact-fetching.hook";
import FieldWrapper from "@/modules/lead-page/new/components/sidebar/fields/field-wrapper";
import { Stack } from "@mui/material";

const MethodOfContactField = () => {
  const { methodOfContact, lead, isLoading, handleConfirmUpdate } =
    useLeadInfo();
  const { permissions: currentUserPermissions } =
    useContext(NawyPassportContext);
  const { partnersData, partnersLoading } = usePartnersWithMethodOfContact(
    methodOfContact.state as UUID
  );

  return (
    <Stack direction="column" alignItems="start" gap={1}>
      <LeadInfoField
        editable={userHasPermission(
          {
            name: PermissionsEnum.JOURNEY_METHOD_OF_CONTACT,
            level: PermissionLevel.WRITE,
          },
          currentUserPermissions
        )}
        setEditModalOpen={methodOfContact.setEditMethodOfContactModalOpen}
        editModalOpen={methodOfContact.editMethodOfContactModalOpen}
        content={methodOfContact.value || "Not Set"}
        editModal={
          <PermissionGuard
            permissions={[
              {
                name: PermissionsEnum.JOURNEY_METHOD_OF_CONTACT,
                level: PermissionLevel.WRITE,
              },
            ]}
          >
            <ResponsiveModal
              open={methodOfContact.editMethodOfContactModalOpen}
              onClose={() => {
                methodOfContact.setEditMethodOfContactModalOpen(false);
                methodOfContact.setState(null);
              }}
              title="Edit Method Of Contact"
              confirmButtonText="Save"
              cancelButtonText="Cancel"
              onConfirm={() => {
                handleConfirmUpdate({
                  lead: {
                    methodOfContactUId: methodOfContact.state ?? undefined,
                    partnerUId:
                      methodOfContact.selectedMethodOfContactPartner ??
                      undefined,
                  },
                });
              }}
              isLoading={isLoading}
              isConfirmDisabled={
                !methodOfContact.state ||
                partnersLoading ||
                (partnersData?.data?.length > 0 &&
                  !methodOfContact.selectedMethodOfContactPartner)
              }
              snapPoints={[1]}
            >
              <FieldWrapper>
                <EditMethodOfContact
                  methodOfContact={methodOfContact}
                  lead={lead}
                  autoFocus
                />
              </FieldWrapper>
            </ResponsiveModal>
          </PermissionGuard>
        }
      />
    </Stack>
  );
};

export default MethodOfContactField;
